
export const contentFeedback=<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5" fill="currentColor"/>
  <polyline points="22 11 17 16 12 11"></polyline>
</svg>
